<p-popover #op>
    {{ process.ProcessDesc }}
</p-popover>

<div class="card">
    <div hidden>
        <p-checkbox
            id="cbxColumnHeader"
            #cbxColumnHeader
            [(ngModel)]="selectedRowsCheckbox.checked"
            [binary]="true"
            [indeterminate]="true"
        ></p-checkbox>
        <!-- <ng-template #loading>
            <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
        </ng-template> -->
        <div id="divStatusHeader">
            <ng-template #headerErrors>
                <i class="material-icons red" [title]="errorHelpText"
                    >highlight_off</i
                >
            </ng-template>
            <ng-template #headerSuccess>
                <i class="material-icons green">check_circle</i>
            </ng-template>
            <ng-template #headerInfo>
                <i class="material-icons" title="Informational Messages"
                    >info_outline</i
                >
            </ng-template>
            <div
                *ngIf="errors?.length; then headerErrors; else headerSuccess"
            ></div>
        </div>
        <!-- <ng-template #loading>
            <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
        </ng-template> -->
    </div>

    <!--<div hidden>
    <div id='taskCNColumnHeader'>
      <ng-template #taskLevel>
        <div class="tabulator-col-content">
          <div class="tabulator-col-title">Charge Numbers & Tasks</div>
          <div class="tabulator-arrow"></div>
        </div>
      </ng-template>
      <ng-template #CNLevel>
        <div class="tabulator-col-content">
          <div class="tabulator-col-title">Charge Numbers</div>
          <div class="tabulator-arrow"></div>
        </div>
      </ng-template>
      <div *ngIf='toggleChecked;then taskLevel else CNLevel'></div>
    </div>
  </div>-->

    <div>
        <p-accordion [multiple]="true">
            <p-accordionTab header="Filters" [selected]="true">
                <form
                    [formGroup]="filterFormGroup"
                    #filterForm="ngForm"
                    id="filterForm"
                >
                    <p-toolbar>
                        <div
                            style="
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                flex-wrap: wrap;
                                justify-content: left;
                            "
                        >
                            <div style="padding-right: 1vw; padding-left: 1vw">
                                <button
                                    pButton
                                    pRipple
                                    class="p-button-text"
                                    label="Clear"
                                    (click)="clearFilters()"
                                ></button>
                            </div>

                            <div
                                *ngIf="tasks as items;"
                                style="padding-right: 1vw"
                            >
                                <p-multiSelect
                                    
                                    [options]="items | orderBy: 'TaskLongName'"
                                    appendTo="body"
                                    optionLabel="TaskLongName"
                                    [filter]="true"
                                    selectedItemsLabel="{0} Task(s) selected."
                                    formControlName="tasks"
                                    [defaultLabel]="this.CNTaskDropdownText"
                                    dataKey="TaskListID"
                                >
                                </p-multiSelect>
                            </div>

                            <div style="padding-right: 1vw">
                                <p-datepicker
                                    formControlName="startDate"
                                    placeholder="Start Date"
                                    [maxDate]="selectedEndDate"
                                    [showIcon]="true"
                                    appendTo="body"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="2000:2030"
                                ></p-datepicker>
                            </div>

                            <div style="padding-right: 1vw">
                                <p-datepicker
                                    formControlName="endDate"
                                    placeholder="End Date"
                                    [minDate]="selectedStartDate"
                                    [showIcon]="true"
                                    appendTo="body"
                                    [monthNavigator]="true"
                                    [yearNavigator]="true"
                                    yearRange="2000:2030"
                                ></p-datepicker>
                            </div>

                            <div>
                                <div style="padding-right: 1vw">
                                    <span class="flex items-center">
                                        <p-checkbox
                                            class="example-margin"
                                            formControlName="taskLevelEntry"
                                            (onChange)="
                                                onToggleTaskLevel($event)
                                            "
                                            #taskLevelEntry
                                            [binary]="true"
                                        >
                                        </p-checkbox>
                                        <label class="ml-2">Include Sub Tasks</label>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </p-toolbar>
                </form>
            </p-accordionTab>
            <p-accordionTab header="Update Multiple Amounts">
                <form
                    [formGroup]="updateFormGroup"
                    #updateForm="ngForm"
                    id="multiUpdate"
                >
                    <p-toolbar>
                        <span class="p-float-label">
                            <input
                                id="float-input"
                                type="text"
                                size="30"
                                formControlName="scheduledAmount"
                                pInputText
                            />
                            <label for="float-input">Scheduled Amount</label>
                        </span>

                        <div style="padding-right: 1vw; padding-left: 1vw">
                            <button
                                pButton
                                class="p-button-secondary"
                                #applyMulti
                                [disabled]="!fpinvoices"
                                label="Apply Updates"
                                icon="pi pi-check"
                                iconPos="left"
                            ></button>
                        </div>
                    </p-toolbar>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div
            class="alternate-text"
            style="
                display: flex;
                flex-direction: row;
                align-items: center;
                flex-wrap: wrap;
                padding-bottom: 0.5vh;
                padding-top: 0.5vh;
            "
            [hidden]="!tabFixedPrice"
        >
            <button
                pButton
                pRipple
                class="p-button-text"
                [disabled]="!tabFixedPrice?.getSelectedData()?.length"
                (click)="clearSelectedFpInvoices()"
                #clearSelection
                label="Clear Selection"
            ></button>

            <span style="padding-right: 1vw">
                {{ tabFixedPrice?.getSelectedData()?.length }}
                row(s) selected.
            </span>

            <div style="align-self: flex-end">
                <p-splitButton
                    id="download-csv"
                    styleClass="p-button-secondary"
                    icon="pi pi-download"
                    pTooltip="Download"
                    [model]="this.downloadOptions"
                    (onClick)="this.downloadTable('csv')"
                ></p-splitButton>
            </div>
            <button style="margin-left: .5em" pRipple pButton label="Hide Scheduled Entries w/o $"
                title="Hide lines that do not yet have $ entered" class="p-button-text"
                (click)="clearLinesWithout$()"></button>
            <button style="margin-left: .5em" pRipple pButton label="Show All"
                title="Show all fixed price entries" class="p-button-text" (click)="showAll()"></button>
        </div>
        <div class="table-container">
            <!-- <div [hidden]="!loadingData" class="page-overlay">
                <div class="page-overlay-content">
                    <div *ngIf="loadingData; then loading"></div>
                </div>
            </div> -->
            <div id="tabFixedPrice"></div>
        </div>
        <!-- <div
            class="page-overlay"
            #tabOverlay
            id="tabOverlay"
            tabindex="0"
            style="display: none"
        ></div> -->
    </div>
</div>
